import {IMAGE_CONFIG, registerLocaleData} from "@angular/common";
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import {ApplicationConfig, LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {provideClientHydration} from '@angular/platform-browser';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideRouter, withViewTransitions} from '@angular/router';
import {authInterceptor} from '@app/core/interceptors/auth.interceptor';
import {errorInterceptor} from "@app/core/interceptors/error.interceptor";
import {provideToastr} from "ngx-toastr";

import {routes} from './app.routes';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withViewTransitions()),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true,
    }),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {appearance: 'outline'}
    },
    {provide: LOCALE_ID, useValue: 'fr-FR'},
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
        disableImageLazyLoadWarning: true
      }
    },

  ]
};
